<template>
    <article class="scrolled-text">
        <div class="c-subheading index psb-20">{{ data.subheading }}</div>
        <div class="c-heading h2 psb-20" v-html="nl2br(data.headline)"></div>
        <div class="c-content" v-html="data.text"></div>
    </article>
</template>

<script setup>
    const props = defineProps({
        data: {
            type: Object,
            default: () => ({})
        }
    });
</script>
